import { responses } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

export default function ResponsesSection() {
  return (
    <section
      id="responses"
      className="scroll-mt-24 border-y border-background-200 bg-background-100/60 py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          index="04"
          eyebrow="Statements"
          title="当事人回应 · 原话与补充说明"
          desc="只摘录公开发布的原文，保留语气，不代为概括。回应里承认了什么、回避了什么，读原话最清楚。"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {responses.map((item, index) => (
            <blockquote
              key={item.role}
              data-reveal
              style={{ transitionDelay: `${index * 80}ms` }}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-double-quotes-l text-base" />
              </div>
              <p className="mt-5 flex-1 text-[14px] leading-[1.9] text-foreground-800">
                {item.content}
              </p>
              <footer className="mt-6 border-t border-background-200 pt-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-label text-xs font-medium text-foreground-900">
                    {item.role}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900">
                    {item.handle}
                  </span>
                </div>
                <time className="mt-2 block font-label text-[11px] tracking-[0.1em] text-foreground-500">
                  发布于 {item.time}
                </time>
              </footer>
            </blockquote>
          ))}
        </div>

        <p className="mt-8 flex items-start gap-2 font-label text-xs leading-relaxed text-foreground-500">
          <i className="ri-shield-check-line mt-0.5 text-sm text-secondary-600" />
          回应均为公开发布内容的原文摘录，涉及个人身份信息已做隐去处理。
        </p>
      </div>
    </section>
  );
}